'use client'
import { useContext, useMemo, useState } from 'react'
import { NextPage } from 'next'

import AuthContext from '../../../context/AuthContext'
import FileUploader from '../../../components/Conversations/FileUploader'
import CsvImportPreview from '../../../components/Conversations/CsvImportPreview'
import ImportedCsvsTable from '../../../components/Conversations/ImportedCsvsTable'
import SubscriptionUpgrade from '../../../components/Pricing/SubscriptionUpgrade'
import ContactAdmin from '../../../components/Pricing/ContactAdmin'
import Loader from '../../../components/Loader/Loader'
import useCompanySubscription from '../../../hooks/queries/useCompanySubscription'

const Conversations: NextPage = () => {
	const authContext = useContext(AuthContext)
	const [dialogOpen, setDialogOpen] = useState(false)
	const [csvFile, setCsvFile] = useState<File | undefined>()
	const { companySubscription, isLoading } = useCompanySubscription()
	const hasStandardSubscription = useMemo(() => {
		return companySubscription?.planId === 'standard'
	}, [companySubscription])

	if (authContext.loading || isLoading) {
		return (
			<div className="flex justify-center p-6">
				<Loader />
			</div>
		)
	}

	const importCsv = (contactsCsv: File) => {
		setCsvFile(contactsCsv)
		setDialogOpen(true)
	}

	if (!hasStandardSubscription) {
		return authContext.isCompanyManager ? (
			<SubscriptionUpgrade />
		) : (
			<ContactAdmin
				description="Uploading contact CSVs to access contact groups on all your team members devices requires a plan
			upgrade."
			/>
		)
	}

	return (
		<div className="p-4 md:p-10 w-full">
			<h2 className="text-4xl font-extrabold text-black mb-8">Conversations</h2>
			{authContext.isCompanyManager && <FileUploader importCsv={importCsv} />}
			<div className="h-8" />
			<ImportedCsvsTable />
			{csvFile && <CsvImportPreview dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} csvFile={csvFile} />}
		</div>
	)
}

export default Conversations
